import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckMark',
  props: {
    checked: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_DodoIcon = _resolveComponent("DodoIcon")!

  return (_ctx.checked)
    ? (_openBlock(), _createBlock(_component_DodoIcon, {
        key: 0,
        name: "check",
        color: "success"
      }))
    : (_openBlock(), _createBlock(_component_DodoIcon, {
        key: 1,
        name: "close",
        color: "danger"
      }))
}
}

})